export default function PartnerSection() {
  return (
    <section id="partner" className="py-12 sm:py-16 lg:py-20 bg-gradient-to-b from-[#F8F9FA] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-[#E879F9]/10 rounded-full mb-4 sm:mb-6">
              <span className="text-sm font-semibold text-[#0B1F3B]">Programma Partner</span>
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1F3B] mb-4 sm:mb-6 leading-tight text-left">
              Programma Partner per Commercialisti
            </h2>
            <p className="text-sm sm:text-base text-[#1C1C1C]/80 mb-4 sm:mb-5 leading-relaxed">
              Diventa partner Brand Capital e offri ai tuoi clienti PMI un servizio di valutazione patrimoniale del brand, ampliando la tua offerta professionale con un servizio ad alto valore aggiunto.
            </p>
            <p className="text-sm sm:text-base text-[#1C1C1C]/70 mb-5 sm:mb-6 leading-relaxed">
              Il programma include formazione tecnica certificata, materiali co-branded, supporto commerciale e un sistema di referral strutturato con commissioni ricorrenti.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5 mb-5 sm:mb-6">
              <div className="flex items-start gap-3">
                <div className="w-11 h-11 flex items-center justify-center bg-[#E879F9] rounded-lg flex-shrink-0">
                  <i className="ri-graduation-cap-line text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-[#0B1F3B] mb-1">Formazione Certificata</h4>
                  <p className="text-sm text-[#1C1C1C]/70 leading-relaxed">
                    Corso tecnico sulla metodologia BCI e sulla valutazione patrimoniale del brand
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-11 h-11 flex items-center justify-center bg-[#E879F9] rounded-lg flex-shrink-0">
                  <i className="ri-file-text-line text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-[#0B1F3B] mb-1">Materiali Co-Brand</h4>
                  <p className="text-sm text-[#1C1C1C]/70 leading-relaxed">
                    Presentazioni, brochure e documenti tecnici personalizzati con il tuo studio
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-11 h-11 flex items-center justify-center bg-[#E879F9] rounded-lg flex-shrink-0">
                  <i className="ri-customer-service-2-line text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-[#0B1F3B] mb-1">Supporto Tecnico</h4>
                  <p className="text-sm text-[#1C1C1C]/70 leading-relaxed">
                    Assistenza continuativa per consulenze complesse e casi particolari
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-11 h-11 flex items-center justify-center bg-[#E879F9] rounded-lg flex-shrink-0">
                  <i className="ri-money-euro-circle-line text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-[#0B1F3B] mb-1">Sistema Referral</h4>
                  <p className="text-sm text-[#1C1C1C]/70 leading-relaxed">
                    Commissioni ricorrenti su ogni cliente acquisito e gestito tramite il tuo studio
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg p-4 sm:p-5 border border-[#0B1F3B]/10">
              <h4 className="text-sm sm:text-base font-semibold text-[#0B1F3B] mb-3 sm:mb-4">Requisiti di Certificazione</h4>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-sm text-[#1C1C1C]/70">
                  <i className="ri-checkbox-line text-[#C9A861] mt-0.5 flex-shrink-0"></i>
                  <span>Iscrizione Albo Commercialisti o Consulenti del Lavoro</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-[#1C1C1C]/70">
                  <i className="ri-checkbox-line text-[#C9A861] mt-0.5 flex-shrink-0"></i>
                  <span>Completamento corso di formazione Brand Capital (16 ore)</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-[#1C1C1C]/70">
                  <i className="ri-checkbox-line text-[#C9A861] mt-0.5 flex-shrink-0"></i>
                  <span>Superamento test di certificazione tecnica</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-[#1C1C1C]/70">
                  <i className="ri-checkbox-line text-[#C9A861] mt-0.5 flex-shrink-0"></i>
                  <span>Portafoglio clienti PMI attivo (minimo 10 aziende)</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="relative order-first lg:order-last">
            <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8">
              <div className="flex items-center gap-4 mb-5 sm:mb-6">
                <div className="w-14 h-14 flex items-center justify-center bg-[#E879F9] rounded-xl">
                  <i className="ri-briefcase-line text-2xl text-white"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-[#0B1F3B]">50+</p>
                  <p className="text-sm text-[#1C1C1C]/60">Partner Certificati</p>
                </div>
              </div>

              <div className="space-y-3 mb-5 sm:mb-6">
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-lg text-[#22C55E] mt-1 flex-shrink-0"></i>
                  <span className="text-sm text-[#1C1C1C]/80">Iscrizione Albo Commercialisti o Consulenti del Lavoro</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-lg text-[#22C55E] mt-1 flex-shrink-0"></i>
                  <span className="text-sm text-[#1C1C1C]/80">Completamento corso di formazione Brand Capital (16 ore)</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-lg text-[#22C55E] mt-1 flex-shrink-0"></i>
                  <span className="text-sm text-[#1C1C1C]/80">Superamento test di certificazione tecnica</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-lg text-[#22C55E] mt-1 flex-shrink-0"></i>
                  <span className="text-sm text-[#1C1C1C]/80">Portafoglio clienti PMI attivo (minimo 10 aziende)</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 sm:mt-10 lg:mt-12 bg-[#0B1F3B] rounded-lg p-6 sm:p-8 text-center">
          <h3 className="font-serif text-xl sm:text-2xl font-bold text-white mb-2 sm:mb-3">
            Diventa Partner Brand Capital
          </h3>
          <p className="text-sm sm:text-base text-white/80 mb-5 sm:mb-6 max-w-2xl mx-auto">
            Compila il modulo per ricevere informazioni dettagliate sul programma partner e sui requisiti di certificazione
          </p>
          <button className="w-full sm:w-auto px-6 sm:px-8 py-3 bg-[#22C55E] text-white rounded-md text-sm sm:text-base font-semibold hover:bg-[#22C55E]/90 transition-all whitespace-nowrap cursor-pointer">
            Richiedi Informazioni Partner
          </button>
        </div>
      </div>
    </section>
  );
}
